import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import AppLayout from "./views/layouts/AppLayout";

export const routerMap = [
  {
    path: "/",
    name: "Root",
    redirect: "/home",
    component: AppLayout
  },
  {
    path: "/",
    component: AppLayout,
    name: "Home",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/home/index"),
        meta: { title: "Home" },
        children: [
          {
            path: "/home/:id",
            name: "Home-details",
            component: () => import("@/views/home/detail"),
            meta: { title: "Home-details" }
          }
        ]
      },

      {
        path: "/joblist",
        name: "Joblist",
        component: () => import("@/views/joblist/index"),
        meta: { title: "Joblist" },
        children: [
          {
            path: ":id",
            name: "Joblist-details",
            component: () => import("@/views/jobdetail/index"),
            meta: { title: "Joblist-details" }
          }
        ]
      },
      {
        path: "/about",
        name: "About",
        component: () => import("@/views/about/index"),
        meta: { title: "About" }
      },
      {
        path: "*",
        redirect: "/home"
      }
    ]
  }
];

export default new Router({
  routes: routerMap,
  mode: "hash"
});
